import React from 'react';
import { Box, } from '@waglabs/box-next';
import styled from 'styled-components';
import { compose, system, } from 'styled-system';
import { lineClamp, } from '@waglabs/styled-system-adjunct';
// Place the default props here specific to each variant
const variantMapping = {
    h1: (props) => (React.createElement(Box, Object.assign({ as: "h1" }, props))),
    h2: (props) => (React.createElement(Box, Object.assign({ as: "h2" }, props))),
    h3: (props) => (React.createElement(Box, Object.assign({ as: "h3" }, props))),
    body1: (props) => (React.createElement(Box, Object.assign({ as: "p" }, props))),
    body2: (props) => (React.createElement(Box, Object.assign({ as: "span" }, props))),
    legal: (props) => (React.createElement(Box, Object.assign({ as: "p" }, props))),
};
const defaults = {
    fontSize: (semantic) => ({
        fontSize: [`mobile-${semantic}`, `tablet-${semantic}`, `desktop-${semantic}`],
    }),
};
const BaseTypography = ({ color = 'medGray', variant = 'body1', fontFamily = 'muli', component, ...rest }) => {
    const Component = component || variantMapping[variant];
    return (React.createElement(Component, Object.assign({ color: color, fontFamily: fontFamily }, defaults.fontSize(variant), rest)));
};
const textTransform = system({
    textTransform: {
        property: 'textTransform',
    },
});
const whiteSpace = system({
    whiteSpace: {
        property: 'whiteSpace',
    }
});
const styleProps = compose(lineClamp, textTransform, whiteSpace);
const StyledTypography = styled(BaseTypography) `
  ${styleProps}
  /* Hover prop is generally used by different consumers to achieve on-hover & cursor effects */
  ${({ hover }) => hover && `
    &:hover {
      cursor: pointer;
    }
  `}
  /**
  * These are the properties that we add if we want to enable 'lineClamp' 
  * look for <TruncatedTypography /> as the best predate component representation
  */
  ${({ lineClamp }) => lineClamp && `
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
  `}
`;
export { StyledTypography as Typography };
